import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
  Stack,
  Chip,
  Rating,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { Close, Phone, WhatsApp, Email, LocationOn, Info } from '@mui/icons-material';
import { buildImageUrl } from '../config/apiConfig';

const ServiceDetailModal = ({ open, onClose, service }) => {
  const [imageError, setImageError] = useState(false);

  if (!service) return null;

  const categoryConfig = {
    'band-baja': { color: '#FF6B6B', bgColor: '#FFE5E5', icon: '🎺', gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%)' },
    'barber': { color: '#FF9F43', bgColor: '#FFF5E6', icon: '💇', gradient: 'linear-gradient(135deg, #FF9F43 0%, #FFB366 100%)' },
    'bike': { color: '#0984E3', bgColor: '#E6F3FF', icon: '🏍️', gradient: 'linear-gradient(135deg, #0984E3 0%, #40B0FF 100%)' },
    'building-material': { color: '#E67E22', bgColor: '#FFEBDB', icon: '🏗️', gradient: 'linear-gradient(135deg, #E67E22 0%, #F39C12 100%)' },
    'bus': { color: '#1565C0', bgColor: '#E3F2FD', icon: '🚌', gradient: 'linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)' },
    'buysell-other': { color: '#00897B', bgColor: '#E0F2F1', icon: '🛒', gradient: 'linear-gradient(135deg, #00897B 0%, #26C6DA 100%)' },
    'cab': { color: '#F1C40F', bgColor: '#FFF8E1', icon: '🚕', gradient: 'linear-gradient(135deg, #F1C40F 0%, #F7DC6F 100%)' },
    'carpenter': { color: '#795548', bgColor: '#EFEBE9', icon: '🪵', gradient: 'linear-gradient(135deg, #795548 0%, #A1887F 100%)' },
    'catering': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🍽️', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'contact-us': { color: '#7B1FA2', bgColor: '#F3E5F5', icon: '📞', gradient: 'linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%)' },
    'delivery-boy': { color: '#00695C', bgColor: '#E0F2F1', icon: '🚴', gradient: 'linear-gradient(135deg, #00695C 0%, #00897B 100%)' },
    'doctor': { color: '#D32F2F', bgColor: '#FFEBEE', icon: '⚕️', gradient: 'linear-gradient(135deg, #D32F2F 0%, #E53935 100%)' },
    'driver': { color: '#455A64', bgColor: '#ECEFF1', icon: '🚗', gradient: 'linear-gradient(135deg, #455A64 0%, #607D8B 100%)' },
    'e-rickshaw': { color: '#00897B', bgColor: '#E0F2F1', icon: '🛺', gradient: 'linear-gradient(135deg, #00897B 0%, #4DB6AC 100%)' },
    'electrician': { color: '#FFB300', bgColor: '#FFF3E0', icon: '⚡', gradient: 'linear-gradient(135deg, #FFB300 0%, #FFD54F 100%)' },
    'emergency': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🚨', gradient: 'linear-gradient(135deg, #E91E63 0%, #F50057 100%)' },
    'gardner': { color: '#2E7D32', bgColor: '#E8F5E9', icon: '🌿', gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)' },
    'gas': { color: '#6A1B9A', bgColor: '#F3E5F5', icon: '⛽', gradient: 'linear-gradient(135deg, #6A1B9A 0%, #8E24AA 100%)' },
    'health-other': { color: '#0288D1', bgColor: '#E1F5FE', icon: '💊', gradient: 'linear-gradient(135deg, #0288D1 0%, #4FC3F7 100%)' },
    'labour': { color: '#E64A19', bgColor: '#FFEBEE', icon: '👷', gradient: 'linear-gradient(135deg, #E64A19 0%, #FF6F4A 100%)' },
    'mantainence-other': { color: '#827717', bgColor: '#F9F6F0', icon: '🔧', gradient: 'linear-gradient(135deg, #827717 0%, #9FA725 100%)' },
    'medical': { color: '#C2185B', bgColor: '#FCE4EC', icon: '🏥', gradient: 'linear-gradient(135deg, #C2185B 0%, #E91E63 100%)' },
    'moto-mech': { color: '#212121', bgColor: '#F5F5F5', icon: '🔩', gradient: 'linear-gradient(135deg, #212121 0%, #424242 100%)' },
    'music-dj': { color: '#AA00FF', bgColor: '#F3E5F5', icon: '🎵', gradient: 'linear-gradient(135deg, #AA00FF 0%, #D500F9 100%)' },
    'new': { color: '#388E3C', bgColor: '#E8F5E9', icon: '⭐', gradient: 'linear-gradient(135deg, #388E3C 0%, #66BB6A 100%)' },
    'other': { color: '#78909C', bgColor: '#ECEFF1', icon: '📌', gradient: 'linear-gradient(135deg, #78909C 0%, #90A4AE 100%)' },
    'painter': { color: '#FF6B9D', bgColor: '#FFE5F0', icon: '🎨', gradient: 'linear-gradient(135deg, #FF6B9D 0%, #FF8FB3 100%)' },
    'pandit-ji': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🙏', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'plumber': { color: '#00897B', bgColor: '#E0F2F1', icon: '🔧', gradient: 'linear-gradient(135deg, #00897B 0%, #4DB6AC 100%)' },
    'potter': { color: '#6D4C41', bgColor: '#EFEBE9', icon: '🏺', gradient: 'linear-gradient(135deg, #6D4C41 0%, #8D6E63 100%)' },
    'raj-mistri': { color: '#E67E22', bgColor: '#FFEBDB', icon: '👷', gradient: 'linear-gradient(135deg, #E67E22 0%, #F39C12 100%)' },
    'restaurants': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🍴', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'teacher': { color: '#2196F3', bgColor: '#E3F2FD', icon: '👨‍🏫', gradient: 'linear-gradient(135deg, #2196F3 0%, #42A5F5 100%)' },
    'tent-house': { color: '#FF9800', bgColor: '#FFE0B2', icon: '⛺', gradient: 'linear-gradient(135deg, #FF9800 0%, #FFB74D 100%)' },
    'water': { color: '#0097A7', bgColor: '#E0F2F1', icon: '💧', gradient: 'linear-gradient(135deg, #0097A7 0%, #00BCD4 100%)' },
  };

  const categoryLower = (service.field || 'other').toLowerCase().replace(/\s+/g, '-');
  const config = categoryConfig[categoryLower] || categoryConfig['other'];

  const getImageUrl = () => {
    if (!service.photo) return null;
    const photo = service.photo.trim();
    return buildImageUrl(photo, 'experts');
  };

  const imageUrl = getImageUrl();

  const handleCall = (phone) => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleWhatsApp = (phone) => {
    if (phone) {
      const message = `Hi, I'm interested in your ${service.field} services.`;
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
    }
  };

  const handleEmail = () => {
    if (service.email) {
      window.location.href = `mailto:${service.email}`;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          maxHeight: '90vh',
        }
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          bgcolor: 'rgba(0,0,0,0.05)',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.1)' },
          zIndex: 10
        }}
      >
        <Close />
      </IconButton>

      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        {/* Hero Section with Image */}
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: 250, sm: 300, md: 350 },
            backgroundColor: '#f5f5f5',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          {imageUrl && !imageError ? (
            <img
              src={imageUrl}
              alt={service.name}
              onError={() => setImageError(true)}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                background: config.gradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: { xs: '3rem', sm: '4rem', md: '5rem' }
              }}
            >
              {config.icon}
            </Box>
          )}
        </Box>

        {/* Content Section */}
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          {/* Header with Name and Rating */}
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    color: '#2d3748',
                    mb: 1,
                    wordBreak: 'break-word',
                    fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.125rem' }
                  }}
                >
                  {service.name}
                </Typography>
                <Chip
                  label={service.field || 'Service'}
                  sx={{
                    background: config.gradient,
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '0.9rem',
                    height: 32
                  }}
                />
              </Box>
            </Box>

            {/* Rating */}
            {service.rating && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Rating value={parseFloat(service.rating) || 0} readOnly size="medium" />
                <Typography variant="body2" sx={{ color: '#718096', fontWeight: 600 }}>
                  {service.rating || 'No rating'} / 5.0
                </Typography>
              </Box>
            )}
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Contact Information */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Phone fontSize="small" sx={{ color: '#667eea' }} />
              Contact Information
            </Typography>

            <Box sx={{ pl: 2 }}>
              {/* Primary Phone */}
              {service.phone1 && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ color: '#718096', mb: 0.5 }}>
                    Primary Phone:
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#667eea',
                      fontWeight: 700,
                      mb: 1
                    }}
                  >
                    {service.phone1}
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      startIcon={<WhatsApp />}
                      onClick={() => handleWhatsApp(service.phone1)}
                      sx={{
                        background: '#25D366',
                        color: '#fff',
                        '&:hover': { background: '#1fbb4f' }
                      }}
                    >
                      WhatsApp
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      fullWidth
                      startIcon={<Phone />}
                      onClick={() => handleCall(service.phone1)}
                      sx={{
                        color: '#667eea',
                        borderColor: '#667eea',
                        '&:hover': { bgcolor: 'rgba(102, 126, 234, 0.05)' }
                      }}
                    >
                      Call
                    </Button>
                  </Stack>
                </Box>
              )}

              {/* Secondary Phone */}
              {service.phone2 && service.phone2 !== service.phone1 && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ color: '#718096', mb: 0.5 }}>
                    Secondary Phone:
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#667eea',
                      fontWeight: 700,
                      mb: 1
                    }}
                  >
                    {service.phone2}
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      startIcon={<WhatsApp />}
                      onClick={() => handleWhatsApp(service.phone2)}
                      sx={{
                        background: '#25D366',
                        color: '#fff',
                        '&:hover': { background: '#1fbb4f' }
                      }}
                    >
                      WhatsApp
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      fullWidth
                      startIcon={<Phone />}
                      onClick={() => handleCall(service.phone2)}
                      sx={{
                        color: '#667eea',
                        borderColor: '#667eea',
                        '&:hover': { bgcolor: 'rgba(102, 126, 234, 0.05)' }
                      }}
                    >
                      Call
                    </Button>
                  </Stack>
                </Box>
              )}

              {/* Email */}
              {service.email && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ color: '#718096', mb: 0.5 }}>
                    Email:
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    startIcon={<Email />}
                    onClick={handleEmail}
                    sx={{
                      color: '#667eea',
                      borderColor: '#667eea',
                      justifyContent: 'flex-start',
                      '&:hover': { bgcolor: 'rgba(102, 126, 234, 0.05)' }
                    }}
                  >
                    {service.email}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Location */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOn fontSize="small" sx={{ color: '#667eea' }} />
              Location
            </Typography>
            <Paper
              sx={{
                p: 2,
                backgroundColor: '#f7fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '8px'
              }}
            >
              <Typography variant="body1" sx={{ color: '#2d3748', fontWeight: 600, mb: 0.5, wordBreak: 'break-word' }}>
                📍 {service.address || 'Address not provided'}
              </Typography>
              {service.city && (
                <Typography variant="body2" sx={{ color: '#718096' }}>
                  City: {service.city}
                </Typography>
              )}
            </Paper>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Rate/Pricing */}
          {service.rate && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', mb: 2 }}>
                💰 Pricing
              </Typography>
              <Paper
                sx={{
                  p: 2,
                  backgroundColor: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.05) 100%)',
                  border: '2px solid #667eea',
                  borderRadius: '8px'
                }}
              >
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#667eea' }}>
                  ₹{service.rate}
                </Typography>
              </Paper>
            </Box>
          )}

          {/* Description/Note */}
          {service.note && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Info fontSize="small" sx={{ color: '#667eea' }} />
                Description
              </Typography>
              <Paper
                sx={{
                  p: 2.5,
                  backgroundColor: '#f7fafc',
                  border: '1px solid #e2e8f0',
                  borderLeft: '4px solid #667eea',
                  borderRadius: '8px'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: '#2d3748',
                    lineHeight: 1.8,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                  }}
                >
                  {service.note}
                </Typography>
              </Paper>
            </Box>
          )}

          <Divider sx={{ mb: 3 }} />

          {/* Details Table */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', mb: 2 }}>
              📋 Details
            </Typography>
            <TableContainer component={Paper} sx={{ backgroundColor: '#f7fafc', border: '1px solid #e2e8f0' }}>
              <Table size="small">
                <TableBody>
                  {service.field && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, color: '#2d3748', width: '40%' }}>
                        Service Type
                      </TableCell>
                      <TableCell sx={{ color: '#667eea', fontWeight: 600 }}>
                        {service.field}
                      </TableCell>
                    </TableRow>
                  )}
                  {service.city && (
                    <TableRow sx={{ backgroundColor: '#f0f4ff' }}>
                      <TableCell sx={{ fontWeight: 700, color: '#2d3748' }}>
                        City
                      </TableCell>
                      <TableCell sx={{ color: '#667eea', fontWeight: 600 }}>
                        {service.city}
                      </TableCell>
                    </TableRow>
                  )}
                  {service.rating && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, color: '#2d3748' }}>
                        Rating
                      </TableCell>
                      <TableCell sx={{ color: '#667eea', fontWeight: 600 }}>
                        {service.rating} / 5.0 ⭐
                      </TableCell>
                    </TableRow>
                  )}
                  {service.id && (
                    <TableRow sx={{ backgroundColor: '#f0f4ff' }}>
                      <TableCell sx={{ fontWeight: 700, color: '#2d3748' }}>
                        Service ID
                      </TableCell>
                      <TableCell sx={{ color: '#718096', fontWeight: 600, fontSize: '0.85rem', wordBreak: 'break-all' }}>
                        {service.id}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Action Buttons */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4, mb: 2 }}>
            {service.phone1 && (
              <>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  startIcon={<WhatsApp />}
                  onClick={() => handleWhatsApp(service.phone1)}
                  sx={{
                    background: '#25D366',
                    color: '#fff',
                    fontWeight: 700,
                    py: 1.5,
                    '&:hover': { background: '#1fbb4f' }
                  }}
                >
                  Message on WhatsApp
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  startIcon={<Phone />}
                  onClick={() => handleCall(service.phone1)}
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: '#fff',
                    fontWeight: 700,
                    py: 1.5
                  }}
                >
                  Call Now
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceDetailModal;